import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useExternalLinkCache } from './cache'
import {
  type ExternalLinkAddInput,
  type ExternalLinkAddSuccess,
  type ExternalLinkData,
  type UnsavedExternalLink,
} from '@terros/common'

export function useAddExternalLink(): AddHookResponse<UnsavedExternalLink, ExternalLinkData> {
  const mutation = useTantalimMutation<ExternalLinkAddInput, ExternalLinkAddSuccess>({ url: '/externalLink/add' })
  const cache = useExternalLinkCache()

  async function add(linkData: UnsavedExternalLink): Promise<ExternalLinkData> {
    const output = await mutation.mutateAsync(linkData)
    cache.addItem(output.externalLink)
    return output.externalLink
  }

  return mutationAdd(mutation, add)
}
